import React from 'react';
import Form, { FormRow } from '../Form/Form';
import Button from '../../UI/Button/Button';
import Input from '../Form/Input';

function Details(props) {
    return (
        <Form {...props}>
            <FormRow>
                <Input type="text" name="name" aria-label="Name" placeholder="Your name" required/>
            </FormRow>
            <FormRow>
                <Input type="email" name="email" aria-label="Email" placeholder="Your email address" required/>
            </FormRow>
            <FormRow>
                <Button type="submit" isLarge={true}>Let's race!</Button>
            </FormRow>
            <FormRow>
                <p>*By participating in Drive to Win,  you consent to receive marketing communications from Crew Clothing. You  can opt out at any time by clicking "unsubscribe" in the footer of our  emails.</p>
            </FormRow>
        </Form>
    );
}

export default Details;